import Vue from "vue";
import Router from "vue-router";

import store from "@/store";
import MainLayout from "@/layouts/Main";

Vue.use(Router);

const router = new Router({
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: "/",
      redirect: "approval",
      component: MainLayout,
      meta: {
        authRequired: true,
        hidden: true,
      },
      children: [
        // test
        {
          path: "/test-token",
          meta: {
            title: "Test token",
          },
          component: () => import("./views/TestToken"),
        },
        // Dashboard
        {
          path: "/dashboard",
          meta: {
            title: "Dashboard",
          },
          component: () => import("./views/Home/index"),
        },
        {
          path: "/reports",
          meta: {
            title: "Reports",
          },
          component: () => import("./views/Reports/Reports"),
        },
        {
          path: "/approval",
          meta: {
            title: "Danh sách phiếu",
          },
          component: () => import("./views/Approval/List"),
          children: [
            // Dashboards
            {
              path: "/approval/",
              meta: {
                title: "Chọn phiếu",
              },
              component: () => import("./views/Approval/EmptyItem"),
            },
            {
              path: "/approval/view/:id",
              meta: {
                title: "Chi tiết phiếu",
              },
              component: () => import("./views/Approval/Detail"),
            },
          ],
        },
      ],
    },

    // System Pages
    {
      path: "/auth",
      component: () => import("@/layouts/Auth"),
      redirect: "auth/login",
      children: [
        {
          path: "/error/404",
          meta: {
            title: "Error 404",
          },
          component: () => import("./views/auth/404"),
        },
        {
          path: "/error/500",
          meta: {
            title: "Error 500",
          },
          component: () => import("./views/auth/500"),
        },
        {
          path: "/auth/login",
          meta: {
            title: "Sign In",
          },
          component: () => import("./views/auth/login"),
        },
        {
          path: "/auth/login/callback",
          meta: {
            title: "Sign In",
          },
          component: () => import("./views/auth/login/callback"),
        },
        {
          path: "/auth/lockscreen",
          meta: {
            title: "Lockscreen",
          },
          component: () => import("./views/auth/lockscreen"),
        },
      ],
    },

    // Redirect to 404
    {
      path: "*",
      redirect: "error/404",
      hidden: true,
    },
  ],
});

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.authRequired)) {
    if (!store.state.auth.userId) {
      next({
        path: "/auth/login",
        query: { redirect: to.fullPath },
      });
    } else {
      next();
    }
  } else {
    next();
  }
});

export default router;
